import { FC } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
  Stack,
  ListItemIcon,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { EmojiObjectsOutlined, FiberManualRecord } from '@mui/icons-material';


export const StoryGuide: FC = () => {
  const guidePoints = [
    'Describe a specific leadership challenge you faced',
    'Explain the actions you took and decisions you made',
    'Share the outcome and what you learned',
    'Highlight your communication style in that situation',
    'Include how you influenced or motivated others',
  ];

  return (
    <Box>
      <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'flex-start', sm: 'center' }} justifyContent="space-between" mb={1}>
        <Typography variant="body1" fontWeight={600} fontSize={14}>
          Your Leadership Story
        </Typography>
        <Typography variant="body2" fontWeight={500} fontSize={12} color="text.secondary">
          Tell your story in your own words
        </Typography>
      </Stack>

      <Box
        sx={{
          border: 1,
          borderRadius: '10px',
          borderColor: 'divider',
        }}
      >
        <Accordion
          disableGutters
          sx={{
            backgroundColor: 'transparent',
            '&:before': {
              display: 'none',
            },
            '.MuiAccordionSummary-content': {
              alignItems: 'center',
              gap: 1,
              ml: 1.5,
            },
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
            <EmojiObjectsOutlined sx={{ fontSize: 22, color: 'warning.main' }}/>
            <Typography variant="body2" fontWeight={500}>Writing guide: What makes a great leadership story?</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ pt: 0 }}>
            <List disablePadding>
              {guidePoints.map((point, index) => (
                <ListItem key={index} dense>
                  <ListItemIcon><FiberManualRecord sx={{ fontSize: 10, color: 'warning.main' }}/></ListItemIcon>
                  <ListItemText secondary={point}/>
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      </Box>

    </Box>
  );
};
